import React from 'react'
import PageMainTitle from 'components/commons/PageMainTitle'
import { pageMainTitle } from 'components/mailmagazine/MailmagazineItems'
import styles from './Mailmagazine.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import CaseStudy from 'components/home/CaseStudy'
import MailmagazineLink from './MailmagazineLink/MailmagazineLink'

const Mailmagazine: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Mail magazine', url: '#' },
  ]
  useHubSpotGenerate('na1', '9395227', 'eb74faac-607d-4e9f-a8ee-2a3398380921', '#sp_hbspt')

  return (
    <>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} isVertical />
      <article className={styles.main}>
        <section className={styles.section}>
          <div className={styles.contents}>
            <div className={styles.description}>
              <div className={styles.description_title}>
                <div className={styles.red_point}></div>
                <h2>Aitria MAIL MAGAZINE</h2>
              </div>
              <p>
                UX/UIデザインの実務的なナレッジ、システム内製化に必要なエンジニアリングのノウハウ、
                ビジネスを加速させるための業界動向やトレンドなど、毎週配信しています。
              </p>
            </div>
            <div className={styles.register}>
              <div className={styles.img}>
                <div className={styles.screen_img}>
                  <img src="/images/img/img_mailmagazine.webp" alt="mailmagazine" className={styles.screen} />
                </div>
              </div>
              <div className={styles.register_form}>
                <h3>メールマガジン登録</h3>
                <div className="mailmagazine_hubSpot" id="sp_hbspt"></div>
              </div>
            </div>
          </div>
        </section>
      </article>
      <CaseStudy tagType="h2" />
      <MailmagazineLink />
    </>
  )
}

export default Mailmagazine
